import * as React from 'react'
import { useTranslate } from 'react-admin'
import { Breadcrumbs, Typography } from '@mui/material'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'

export const CustomizedBreadcrumbs = ({ module, entity, state }) => {
    const translate = useTranslate()
    if (entity == 'my-devices'){
      return null
    }
    return (
      <div role='presentation' className='breadcrumbLinks'>
        <Breadcrumbs
          separator={<ArrowRightIcon sx={{ fontSize: 16 }} />}
          aria-label='breadcrumb'
          sx={{
            '& .MuiTypography-root': {
              fontSize: '0.9em',
            },
            '& .MuiBreadcrumbs-separator': {
              marginLeft: '2px',
              marginRight: '2px',
            },
          }}
        >
          {module && entity && <Typography key='1'> {translate(`ra.modules.${module}`)}</Typography>}
          {entity && <Typography key='2'>{translate(`ra.entity.${entity}`)}</Typography>}
          {state && <Typography key='3'>{state}</Typography>}
        </Breadcrumbs>
      </div>
    )
}
